<template>
  <div>
    <div class="row">
      <div class="col-12 w-100">
        <p class="pb-2 color-green-2">
          O vínculo entre treinamento e certificado só pode começar a partir do
          dia seguinte à criação, garantindo que os certificados dos
          treinamentos em andamento na data da criação não sejam afetados. Para
          treinamentos com data de início futura, o vínculo passará a valer a
          partir do início do treinamento.
        </p>
        <p class="pb-2 color-green-2">
          Apenas certificados com vigência dentro do período do treinamento
          serão exibidos para seleção.
        </p>
      </div>
    </div>
    <b-card border-variant="light" class="custom-card mb-4">
      <b-form id="alter-form" class="alter-form">
        <b-form-row>
          <b-col> TREINAMENTO </b-col>
          <b-col v-if="training">
            <b-form-input
              class="isDisabled"
              v-model.lazy.trim="training.name"
            />
          </b-col>
        </b-form-row>
        <b-form-row class="custom-text">
          <b-col> CERTIFICADO </b-col>
          <b-col>
            <b-form-select
              :disabled="showWarnFuture"
              v-model.lazy.trim="form.certificate"
              :state="validateField('certificate')"
              :options="certificateOptions"
              ref="certificate"
              v-on:change="onChangeCertificate"
            />
          </b-col>
        </b-form-row>
        <b-form-row
          class="custom-text pl-3 pr-5"
          style="height: 100%"
          v-if="form.certificate"
        >
          <b-col class="position-relative">
            <div>DATA INÍCIO DO VÍNCULO</div>

            <div class="data-limite-text" v-if="dataLimitStartLinked">
              <span v-if="dataLimitStartLinked">
                A partir da data {{ dataLimitStartLinked }}
              </span>
            </div>
          </b-col>

          <b-col>
            <date-picker
              datePickerId="dateStarted"
              :key="getKeyDate(form.dateStarted)"
              :dataValue="form.dateStarted"
              :state="onValidateFieldCustom('dateStarted', dataStartErrorMsg)"
              @datePickerChangedValue="onChangedDateStarted"
              :required="true"
            />
          </b-col>

          <div
            class="invalid text-invalid-right pr-5"
            v-show="dataStartErrorMsg != null"
          >
            {{ dataStartErrorMsg }}
          </div>
        </b-form-row>
        <b-form-row v-if="showWarnFuture">
          <b-col>
            <span class="circle-icon">!</span>
            <div class="warn-future">
              É permitido apenas um vínculo com data futura. Para adicionar um
              novo, exclua o vínculo futuro já existente.
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="d-flex justify-content-end">
            <b-button
              form="alter-form"
              :disabled="loading || showWarnFuture"
              type="button"
              variant="outline-primary"
              @click="this.cancelForm"
            >
              Cancelar
            </b-button>
            <b-button
              :disabled="loading || showWarnFuture"
              form="alter-form"
              type="button"
              class="ml-3"
              variant="primary"
              @click="onVincularHandler"
            >
              {{
                !form.idLinkCertificateTraining ? "Vincular" : "Alterar Vínculo"
              }}
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>

    <b-card border-variant="light" class="custom-card" v-show="!loading">
      <b-table
        responsive
        class="table-training-links spaced-text"
        :fields="fieldsTrainingLink"
        :items="listLinkedCertificateTraining"
        v-show="!loading"
        show-empty
        empty-text="Nenhuma informação para exibir!"
      >
        <template #cell(status)="data">
          <div
            v-if="data.item.status == 'CURRENT'"
            class="status-icon status-current"
            title="Ativo"
          ></div>
          <div
            v-if="data.item.status == 'FINISHED'"
            class="status-icon status-finished"
            title="Inativo"
          ></div>
          <div
            v-if="data.item.status == 'FUTURE'"
            class="status-icon status-future"
            title="Futuro"
          ></div>
        </template>

        <template #cell(endDate)="data">
          <div v-if="data.item.endDate"
          >{{ data.item.endDate }}</div>
          <div v-if="!data.item.endDate"
          >Indeterminado</div>
        </template>

        <template #cell(action)="data">
          <div
            v-if="data.item.action.canDelete"
            class="icon icon-delete-enable"
            title="Delete"
            @click="onDelete(data.item)"
          ></div>
        </template>
      </b-table>
    </b-card>

    <success-modal
      ref="success-modal"
      :description="this.msgSuccess"
      buttonText="Ok, entendi!"
    />

    <attention-modal
      modalId="cancel-link-certificate-modal"
      title="Atenção!"
      submitButtonText="Sim, vincular"
      cancelButtonText="Prosseguir sem vincular"
      ref="cancel-link-certificate-modal"
      :onAction="this.onAttentionConfirm"
    >
      <template slot="description">
        <p class="p1 mb-4 text-center">
          Todas as alterações realizadas serão perdidas com esta ação.
        </p>
        <p class="p1 mb-4 text-center w-100">
          Deseja vincular o certificado antes de prosseguir?
        </p>
      </template>
    </attention-modal>
    <attention-modal
      modalId="delete-link-certificate-modal"
      title="Atenção!"
      submitButtonText="Sim, excluir"
      cancelButtonText="Não tenho certeza"
      ref="delete-link-certificate-modal"
      :onAction="this.onDeleteConfirm"
    >
      <template slot="description">
        <p class="delete-message p1 mb-4 text-center">
          Tem certeza que deseja excluir este vínculo?
        </p>
      </template>
    </attention-modal>
  </div>
</template>

<script>
import RoutesPaths from "../../../router/router-structure/routes-paths";

import DatePicker from "../../../components/date-picker/DatePicker.vue";

import {
  validateCheckBox,
  validateField,
  requiredFieldsFilled,
  validateFieldStartDate,
  validateFieldFile,
} from "../../../utils/validate/validate.js";

import { createToast } from "../../../components/toast/toast";
import {
  getCertificates,
  getTrainingById,
  saveLinkCertificateTraining,
  getLinkedCertificates,
  deleteLinkCertificateTraining,
} from "../../../services/link-cretificate-training/linkCertificateTrainingService";
import SuccessModal from "../../../components/base-modals/SuccessModal.vue";
import AttentionModal from "../../../components/base-modals/AttentionModal.vue";

const DEFAULT_FORM = {
  dateStarted: null,
  certificate: null,
};
export default {
  components: {
    DatePicker,
    SuccessModal,
    AttentionModal,
  },
  data: function () {
    return {
      leftInfo: "",
      leftAction: {
        text: "Editar Vínculo",
        onClick: this.leftActionClickHandler,
      },
      fieldsTrainingLink: [
        {
          key: "nameCertificate",
          label: "Certificados já vinculados",
          thStyle: { width: "50%" },
        },
        {
          key: "startDate",
          label: "Início Vínculo",
          thStyle: { width: "15%" },
        },
        {
          key: "endDate",
          label: "Fim Vínculo",
          thStyle: { width: "15%" },
        },
        {
          key: "numberCertificatesIssued",
          label: "Emitidos",
          class: "text-center",
          thStyle: { width: "5%" },
        },
        {
          key: "status",
          label: "Status",
          class: "text-center",
          thStyle: { width: "5%" },
        },
        {
          key: "action",
          label: "",
          class: "text-center",
          thStyle: { width: "5%" },
        },
      ],
      dataLimitStartLinked: null,
      training: {},
      itemToDelete: null,
      msgSuccess: null,
      dataStartErrorMsg: null,
      formSubmited: false,
      dateStartedKey: null,
      loading: false,
      originalValues: DEFAULT_FORM,
      form: DEFAULT_FORM,
      files: [],
      certificateOptions: [],
      listLinkedCertificateTraining: [],
      validations: {},
      validateField,
      validateCheckBox,
      requiredFieldsFilled,
      validateFieldFile,
      validateFieldStartDate,
    };
  },
  async mounted() {
    this.globalLoading = false;
    if (!this.$route.params.id) {
      createToast(
        "Atenção",
        "Informações do treinamento não foram cadastradas.",
        "warning"
      );
      this.leftActionClickHandler();
      return;
    }
    this.resetForm();
    this.training = await getTrainingById(this.$route.params.id);
    this.listLinkedCertificateTraining =
      await this.getListCertificationsLinked();

    this.initCertificateOptions();
  },
  computed: {
    showWarnFuture() {
      return (
        Array.isArray(this.listLinkedCertificateTraining) &&
        this.listLinkedCertificateTraining.some((r) => r.status === "FUTURE")
      );
    },
  },
  methods: {
    onAttentionConfirm(value) {
      if (value) {
        //fazer vinculo?
      } else {
        this.resetForm();
        this.$router.push(
          RoutesPaths.linkCertificationTrainingManagement.rootName()
        );
      }
    },
    async onDeleteConfirm(value) {
      if (value) {
        await deleteLinkCertificateTraining(this.itemToDelete);
        this.listLinkedCertificateTraining =
          await this.getListCertificationsLinked();
      }
    },
    cancelForm() {
      const modal = this.$refs["cancel-link-certificate-modal"].$children[0];
      modal.show();
    },
    leftActionClickHandler() {
      this.$router.push(
        RoutesPaths.linkCertificationTrainingManagement.rootName()
      );
    },
    async initCertificateOptions() {
      this.certificateOptions = await this.getCertificateTrainings();
    },
    async onChangeCertificate(certificate) {
      try {
        this.form.dateStarted = null;
        this.form.certificate = certificate;
        this.dataLimitStartLinked = certificate.dateStart;
      } catch (error) {
        this.loading = false;
        console.error("onChangeCertificate", error);
        createToast(
          "Atenção",
          "Ocorreu um erro carregar as regras de data trainamento."
        );
      }
    },
    async getCertificateTrainings() {
      this.loading = true;
      try {
        var responseData = await getCertificates(this.$route.params.id);
        var response = this.buildSelectCertificateOptions(responseData);
        return response;
      } catch (error) {
        console.error("getCertificateTrainings", error);
        createToast(
          "Atenção",
          "Ocorreu um erro carregar as informações de certificados."
        );
      } finally {
        this.loading = false;
      }
    },
    buildSelectCertificateOptions(formDataOptions) {
      return [
        { value: null, text: "Selecione um certificado", disabled: true },
        ...formDataOptions.map((formData) => ({
          value: formData,
          text: formData.name,
        })),
      ];
    },
    onDelete(item) {
      if (!item.action.canDelete) return;

      this.itemToDelete = item.idLinkCertificateTraining;
      const modal = this.$refs["delete-link-certificate-modal"].$children[0];
      modal.show();
    },
    clearError() {
      this.dataStartErrorMsg = null;
    },
    getKeyDate(date) {
      return date?.toString();
    },
    onChangedDateStarted(value) {
      this.clearError();
      this.form.dateStarted = value;
    },
    resetForm() {
      this.form = { ...DEFAULT_FORM };
      this.form.idLinkCertificateTraining = null;
      this.listLinkedCertificateTraining = [];
      this.itemToDelete = null;
      this.clearError();
    },
    async getListCertificationsLinked() {
      try {
        return await getLinkedCertificates(this.$route.params.id);
      } catch (error) {
        this.loading = false;
        console.error("getListCertificationsLinked", error);
        createToast(
          "Atenção",
          "Ocorreu um erro ao listar os certificados vinculados."
        );
      }
    },
    parseDate(dateStr) {
      if (!dateStr) return null;

      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return new Date(`${dateStr}T00:00:00`);
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        const [day, month, year] = dateStr.split("/");
        return new Date(`${year}-${month}-${day}T00:00:00`);
      }

      return null;
    },
    validateDateInRange(dateToCheck, startDate) {
      const date = this.parseDate(dateToCheck);
      const start = this.parseDate(startDate);

      if (!date) return false;
      if (start && date < start) return false;

      return true;
    },
    onValidateFieldCustom(field, msgError) {
      let resp = this.validateField(field);
      if (this.form[field] && this.form.certificate) {
        if (
          !this.validateDateInRange(this.form[field], this.dataLimitStartLinked)
        ) {
          msgError = "Data início fora do período de vigência aceitável.";
        }
      }
      if (resp) {
        resp = (resp && msgError == null) || msgError == "";
      } else if (msgError != null && msgError != "") {
        resp = false;
      }
      return resp;
    },
    requiredFieldsFilledInternal() {
      const isValidDateStart = this.onValidateFieldCustom(
        "dateStarted",
        this.dataStartErrorMsg
      );
      let checkDates = isValidDateStart == null || isValidDateStart == true;
      const checkRequiredFields = this.requiredFieldsFilled();
      return checkDates && checkRequiredFields;
    },
    onVincularHandler() {
      this.formSubmited = true;

      if (this.requiredFieldsFilledInternal()) {
        this.saveLinkedTraining();
        this.formSubmited = false;
      }
    },
    async saveLinkedTraining() {
      try {
        const request = {
          idTraining: this.$route.params.id,
          idCertificate: this.form.certificate?.id,
          startDate: this.form.dateStarted,
        };
        await saveLinkCertificateTraining(request);
        this.msgSuccess = "Certificado salvo com sucesso.";
        const modal = this.$refs["success-modal"].$children[0];
        modal.show();
        this.resetForm();
        this.listLinkedCertificateTraining =
          await this.getListCertificationsLinked();
      } catch (error) {
        this.loading = false;
        console.error("Erro no saveLinkedTraining:", error);
        const msg =
          error?.response?.data?.message ||
          "Ocorreu um erro ao salvar o vínculo.";
        createToast("Atenção", msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.b-form-tags-button {
  display: none;
}
</style>
<style lang="scss" scoped>
.align-right-all-time {
  position: absolute;
  right: 4px;
}
.b-form-tags-input {
  font-size: 1.2rem;
}
.b-form-tag-content {
  font-size: 1.1rem;
}
.b-form-tag > button.b-form-tag-remove {
  font-size: 180%;
}
.col-tooltip {
  max-width: 0.2rem;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.custom-div-reload {
  display: grid;
  grid-template-columns: auto 24px;
}
.custom-reload {
  cursor: pointer;
}
.icon {
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;

  &-ordering {
    background-image: url("../../../assets/icons/arrow-collapse-vertical.svg");
    float: left;
  }

  &-folder {
    background-image: url("../../../assets/icons/folder-outline.svg");
    margin: auto;
  }

  &-edit {
    background-image: url("../../../assets/icons/pencil-outline.svg");
    float: left;

    &:hover {
      background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
      background-image: url("../../../assets/icons/pencil-outline-houver.svg");
      background-position: center;
      border-radius: 30px;
    }
  }

  &-delete-enable {
    background-image: url("../../../assets/icons/trash-can-outline.svg");
    float: left;

    &:hover {
      background: #fbe9ed 0% 0% no-repeat padding-box;
      background-image: url("../../../assets/icons/trash-can-outline-houver.svg");
      background-position: center;
      border-radius: 30px;
    }
  }

  &-delete-disable {
    float: left;
    background-image: url("../../../assets/icons/trash-can-outline-disable.svg");

    &:hover {
      cursor: default !important;
    }
  }

  &-duplicate {
    background-image: url("../../../assets/icons/clone.svg");
    float: left;
    margin-left: 6px;

    &:hover {
      background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
      background-image: url("../../../assets/icons/clone-hover.svg");
      background-position: center;
      border-radius: 30px;
    }
  }

  &:hover {
    cursor: pointer;
  }
}

.column-actions-content {
  margin: auto;
  width: 55px;
}

.disable-icon {
  opacity: 49.8%;
  cursor: not-allowed !important;
}

.col-tooltip {
  max-width: 0.2rem;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.align-right-all-time {
  position: absolute;
  right: 4px;
}
.b-form-tags-input {
  font-size: 1.2rem;
}
.b-form-tag-content {
  font-size: 1.1rem;
}
.form-flex-row {
  display: flex;
  flex-direction: row;
}
.custom-text {
  color: var(--grey-1);
}
.text-invalid-right {
  width: 100%;
  text-align: right;
}
.invalid {
  color: #dc3545;
  text-transform: none;
}
.info-header {
  display: grid;
  width: 100%;
  grid-template-columns: 30px auto;
}
.text-div-table {
  font: normal normal normal 16px/19px Trebuchet MS;
  color: #23272b;
  opacity: 1;
  margin-top: 2em;
  margin-bottom: 1em;
}

.custom-icon-edit {
  background-image: url("../../../assets/icons/pencil-outline.svg");
  background-repeat: no-repeat;
  width: 28px;
  height: 28px;
  border-radius: 30px;
  background-position: center;
  margin-right: 1rem;
  cursor: pointer;
  &:hover {
    background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
    background-image: url("../../../assets/icons/pencil-outline-houver.svg");
    background-position: center;
  }
}

.custom-icon-delete {
  background-image: url("../../../assets/icons/trash-can-outline.svg");
  background-repeat: no-repeat;
  width: 28px;
  height: 28px;
  border-radius: 30px;
  background-position: center;
  &:hover {
    background: rgba(213, 36, 83, 0.1) 0% 0% no-repeat padding-box;
    background-image: url("../../../assets/icons/trash-can-outline-houver.svg");
    background-position: center;
  }
}
.custom-actions {
  width: 90%;
}
.button-edit-container {
  display: flex; /* Ativa o Flexbox */
  justify-content: flex-end; /* Alinha os itens à direita */
  gap: 10px;
}
.box-button-edit {
  padding-top: 30px;
  padding-bottom: 16px;
}
.box-button-edit:last-child {
  margin-right: 26px; /* Adiciona o margin-right apenas ao último elemento */
}
.isDisabled {
  pointer-events: none;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.6;
}
.status-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  margin-top: 3px;
}

.status-current {
  background-color: #009c64;
}

.status-finished {
  background-color: #00000029;
}

.status-future {
  background-color: #b1d34b;
}

.data-limite-text {
  position: absolute;
  top: 22px;
  font-size: 0.9rem;
}

.position-relative {
  position: relative;
}
.custom-navba.custom-navbar .nav-item:only-child {
  border-bottom: 0px;
}
p {
  font-size: 11px;
}
.delete-message {
  width: 100%;
}
.warn-future {
  color: #f47920;
  font: normal normal normal 7px Trebuchet MS;
}
.circle-icon {
  width: 12px;
  height: 12px;
  border: 1.5px solid #f47920; /* Borda amarela */
  color: #f47920;
  font-weight: bold;
  font-size: 8px;
  text-align: center;
  line-height: 10px; /* Centraliza o ! */
  border-radius: 50%;
  display: inline-block;
  margin-right: 2px; /* Espaço entre ícone e texto */
  vertical-align: middle;
  opacity: 0.8;
}
</style>
<style lang="scss">
div.table-training-links td {
  color: #7a7e83;
}
</style>
